import { useQuery } from "@apollo/client";
import {
  Card,
  Drawer,
  LoadingOverlay,
  ScrollArea,
  useMantineTheme,
} from "@mantine/core";
import EditIcon from "@mui/icons-material/Edit";

import { showNotification } from "@mantine/notifications";
import { Box } from "@mui/material";
import { GET_PRODUCT_RETURN } from "apollo/queries";
import ProductDetailModal from "components/Product/ProductDetail";
import AddPriceModal from "components/Product/addPrice";
import ChangeStatusAddModal from "components/Product/changeStatus";
import ActionButton from "components/controls/ActionButtonNew";
import B2bTable from "components/reusable/b2bTable";
import { customLoader } from "components/utilities/loader";
import { useEffect, useState } from "react";
import { formatNumber } from "utiles/url";

const ProductReturn = () => {
  const [size, setSize] = useState("10");
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [hasMounted, setHasMounted] = useState(false);
  const [openedEdit, setOpenedEdit] = useState(false);
  const [openedDetail, setOpenedDetail] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [confirmedSearch, setConfirmedSearch] = useState("");
  const [editId, setEditId] = useState();
  const [deleteID, setDeleteID] = useState(false);
  const [openedAddPrice, setOpenedAddPrice] = useState(false);

  const theme = useMantineTheme();
  const handleManageProduct = (id) => {
    setEditId(id);
    setOpenedEdit(true);
  };
  const { data, loading, fetchMore, refetch } = useQuery(GET_PRODUCT_RETURN, {
    variables: {
      first: parseInt(size),
      page: activePage,
      status: "PAYMENT_REQUEST",
      ordered_by: [
        {
          column: "CREATED_AT",
          order: "DESC",
        },
      ],
      search: searchValue,
    },

    onCompleted: (data) => {
      setTotal(data?.productReturns.paginatorInfo.lastPage);
    },

    onError(error) {
      showNotification({
        color: "red",
        title: "Error",
        message:
          error?.graphQLErrors?.[0]?.message || "Failed to delete products ",
      });
    },
  });
  useEffect(() => {
    refetch();
  }, []);
  const handlePageSizeChange = (newSize) => {
    setSize(newSize);
    setActivePage(1);
  };

  useEffect(() => {
    setHasMounted(true);
  }, []);

  const handleChange = (currentPage) => {
    fetchMore({
      variables: {
        first: parseInt(size),
        page: currentPage,
      },
    });
    setActivePage(currentPage);
  };

  if (!hasMounted) {
    return null;
  }

  const headerData = [
    {
      label: "Product Name",
      key: "name",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        return <span>{rowData.orderItem.product_sku.product.name}</span>;
      },
    },
    {
      label: "Price",
      key: "price",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        return <span>{rowData.orderItem.price}</span>;
      },
    },
    {
      label: "Quantity",
      key: "quantity",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        return <span>{rowData.quantity}</span>;
      },
    },
    {
      label: "Status",
      key: "status",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        return <span>{rowData.status}</span>;
      },
    },
    {
      label: "Reason",
      key: "reason",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        return <span>{rowData.reason}</span>;
      },
    },
    {
      label: "Actions",
      key: "actions",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        return (
          <>
            {rowData.status === "PAYMENT_REQUEST" && (
              <ActionButton
                label="Change Status"
                onClick={() => handleManageProduct(`${rowData.id}`)}
              >
                <EditIcon style={{ fontSize: "1rem" }} />
              </ActionButton>
            )}
          </>
        );
      },
    },
  ];

  const handleManualSearch = (searchTerm) => {
    setSearchValue(searchTerm);
  };
  const clearInput = () => {
    setSearchValue("");
    setConfirmedSearch("");
  };

  return loading ? (
    <LoadingOverlay
      visible={loading}
      color="blue"
      overlayBlur={2}
      loader={customLoader}
    />
  ) : (
    <div style={{ width: "98%", margin: "auto" }}>
      <Drawer
        opened={openedDetail}
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
        title="Product Detail"
        padding="xl"
        onClose={() => setOpenedDetail(false)}
        position="bottom"
        size="80%"
      >
        <ProductDetailModal
          total={total}
          setTotal={setTotal}
          activePage={activePage}
          setActivePage={setActivePage}
          setOpenedDetail={setOpenedDetail}
          Id={editId}
        />
      </Drawer>

      <Drawer
        opened={openedEdit}
        onClose={() => setOpenedEdit(false)}
        styles={{
          closeButton: {
            color: "black",
            marginTop: "50px",
          },
        }}
        padding="xl"
        position="right"
        size="40%"
      >
        <ChangeStatusAddModal
          openedEdit={openedEdit}
          setOpened={setOpenedEdit}
          id={editId}
        />
      </Drawer>

      <Drawer
        opened={openedAddPrice}
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
        onClose={() => setOpenedAddPrice(false)}
        title="Add Price"
        padding="xl"
        size="80%"
        position="bottom"
      >
        <AddPriceModal
          openedEdit={openedAddPrice}
          setOpened={setOpenedAddPrice}
          productData={deleteID}
        />
      </Drawer>
      <Card shadow="sm" p="lg">
        <ScrollArea>
          <B2bTable
            total={total}
            activePage={activePage}
            handleChange={handleChange}
            header={headerData}
            clearInput={clearInput}
            handelSearch={handleManualSearch}
            searchValue={confirmedSearch}
            onSearchChange={setConfirmedSearch}
            loading={loading}
            data={data?.productReturns?.data || []}
            size={size}
            handlePageSizeChange={handlePageSizeChange}
          />
        </ScrollArea>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
            flexDirection: "column",
            p: 1,
            gap: 1,
            m: 1,
            bgcolor: "background.paper",
            borderRadius: 1,
          }}
        >
          <div
            style={{
              marginRight: "35px",
              fontWeight: "bold",
              fontSize: "15px",
            }}
          >
            Total Price: {formatNumber(data?.productReturns?.total_price)}
          </div>
        </Box>
      </Card>
    </div>
  );
};

export default ProductReturn;
